import React, { useEffect } from 'react';
import cn from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';
import { FiHelpCircle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useToggle } from 'react-use';

import { IconButton, useBreakpoints } from '@mssgme/ui';
import { CardsIcon } from '@mssgme/cards';
import { useUnreadConversations } from '@mssgme/inbox';
import { DeprecatedChatsIcon, GitBranchIcon } from '@mssgme/icons';
import { useExperiments, useSwitchApp } from '@mssgme/hooks';
import LogoIcon from '@mssgme/ui/icons/logo-legacy.svg';
import BotsIcon from '@mssgme/app/icons/botIcon.svg';
import SettingsIcon from '@mssgme/app/icons/settings_new.svg';
import IconBurger from '@mssgme/app/icons/iconBurger.svg';

import SidebarNavItem from './SidebarNavItem';

import styles from './Sidebar.scss';
import Backdrop from './Backdrop';

// don't know why need
// const pageActiveFn = (match, location) => match && match.url.startsWith('/p') && !location.pathname.startsWith('/help');

// const SWITCH_TO = 'next';

export default function Sidebar() {
    const { t } = useTranslation();
    const location = useLocation();
    const { hasUnreads } = useUnreadConversations();
    const { isInboxDisplayed } = useExperiments();
    const { isMobile } = useBreakpoints();
    const [isOpen, toggle] = useToggle(false);
    // const switchApp = useSwitchApp();

    // const onSwitch = (e) => {
    //     e.preventDefault();
    //     switchApp(SWITCH_TO);
    // };

    useEffect(() => {
        toggle(false);
    }, [isMobile, location]);

    return (
        <aside className={cn(styles.root)}>
            <header className={styles.header}>
                <IconButton className={cn(styles.menuBtn, { [styles.marked]: hasUnreads })} onClick={toggle}>
                    <IconBurger className={styles.menuIcon} />
                </IconButton>
            </header>
            <nav className={cn(styles.nav, { [styles.visible]: isOpen })}>
                <div>
                    <NavLink className={styles.logo} to="/">
                        <LogoIcon />
                    </NavLink>
                    <SidebarNavItem to="/p" label={isMobile ? t('MobileMenu.page') : 'Page'}>
                        <CardsIcon />
                    </SidebarNavItem>
                    {isInboxDisplayed && (
                        <SidebarNavItem
                            to="/i"
                            label={isMobile ? t('MobileMenu.chats') : 'Chats'}
                            isMarked={hasUnreads}
                        >
                            <DeprecatedChatsIcon />
                        </SidebarNavItem>
                    )}
                    {/*<SidebarNavItem as="a" href="#" label="Sites" onClick={onSwitch}>*/}
                    {/*    <GitBranchIcon />*/}
                    {/*</SidebarNavItem>*/}
                </div>
                <div>
                    <SidebarNavItem to="/help" title="Help" label={isMobile ? t('MobileMenu.help') : null}>
                        <FiHelpCircle />
                    </SidebarNavItem>
                    <SidebarNavItem to="/s" title="Settings" label={isMobile ? t('MobileMenu.settings') : null}>
                        <SettingsIcon />
                    </SidebarNavItem>
                </div>
            </nav>
            {isMobile && <Backdrop isOpen={isOpen} onClose={() => toggle(false)} />}
        </aside>
    );
}
